import { Box, Grid, Toolbar, Typography, useTheme } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	EnhancedRadioGroupRHF,
	LabelPosition,
} from "@websential/cosmic-v20";
import { FC, useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Avatar } from "primereact/avatar";
import Card from "@mui/material/Card";
import { Divider } from "primereact/divider";
import { EnhancedButtonPrimeReact } from "../../EnhancedButtonPrimeReact";
import { EnhancedButtonPrimeReactSeverity } from "../../../common/Common";
import NewFoundLogo from "/src/images/NF.png"
import Ontario from "/src/images/ON.png"
import albertaLogo from "/src/images/AB.png"
import brithisColumbia from "/src/images/BC.png"
import manitobaLogo from "/src/images/MB.png"
import newBrunswickLogo from "/src/images/NB.png"
import norhtWestLogo from "/src/images/NT.png"
import novaScotiaLogo from "/src/images/NS.png"
import nunavutLogo from "/src/images/NU.png"
import princeEdwardLogo from "/src/images/PE.png"
import quebecLogo from "/src/images/QC.png"
import saskatchewanLogo from "/src/images/SK.png"
import { statoryHolidayProvinceCardsData } from "./StatutoryHolidayConstantData";
import { useNavigateToLogout } from "../../../common/Common";
import yukonLogo from "/src/images/YK.png"

interface IStatutoryHolidaysProvinceCards {
	onSubmitPayCalculationsRules: (shortCode: string, label: string) => void;
	onResetCardButtonClicked: (shortCode: string, label: string) => void;
	cardDisableOption: boolean;
	statutoryHolidayDDL: any;
	setSelectedProvinceId: (value: any) => void
	setSelectedProvinceSC: (value: any) => void
	provinceDDL: any
	clientProvince: any

}

export const StatutoryHolidaysProvinceCards: FC<
	IStatutoryHolidaysProvinceCards
> = ({
	onResetCardButtonClicked,
	onSubmitPayCalculationsRules,
	cardDisableOption,
	statutoryHolidayDDL,
	setSelectedProvinceId,
	setSelectedProvinceSC,
	provinceDDL,
	clientProvince
}) => {
		const theme = useTheme();
		const navigateToLogout = useNavigateToLogout();

		const [openCard, setOpenCard] = useState<{ [key: string]: boolean }>({});
		const onProvinceSelectionChangeHandler = (selectedItem: any, index?: any) => {
			setSelectedProvinceSC(selectedItem.shortCode);
			const selectedProvince = provinceDDL && provinceDDL.find((x: any) => x.label === selectedItem.header);
			setSelectedProvinceId(selectedProvince.value);

			const provinceShortCode = selectedItem.shortCode;
			setOpenCard((prevState) => ({
				...prevState,
				[provinceShortCode]: !prevState[provinceShortCode],
			}));
		};
		const getCardStyles = (provinceShortCode: string) => {

			return {
				borderLeft: openCard[provinceShortCode]
					? `4px solid ${theme.palette.primary.main}`
					: "2px solid transparent",
				cursor: "pointer",
			};
		};

		const provinceImages: any = {
			AB: albertaLogo,
			BC: brithisColumbia,
			MB: manitobaLogo,
			NT: norhtWestLogo,
			NB: newBrunswickLogo,
			NS: novaScotiaLogo,
			NU: nunavutLogo,
			NL: NewFoundLogo,
			PE: princeEdwardLogo,
			ON: Ontario,
			QC: quebecLogo,
			SK: saskatchewanLogo,
			YT: yukonLogo,
		};

		useEffect(() => {
			if (clientProvince) {
				setSelectedProvinceSC(clientProvince.shortCode);
				setSelectedProvinceId(clientProvince.id);
				setOpenCard((prev: any) => ({
					...prev,
					[clientProvince.shortCode]: true,
				}));
			}
		}, [clientProvince]);

		return (
			<Grid
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					marginTop: "15px",
				}}
			>
				<Box>
					<Box>
						{cardDisableOption === true &&
							statoryHolidayProvinceCardsData.map((item: any, index: any) => (
								<Card
									sx={{
										padding: 0,
										borderRadius: "8px",
										marginBottom: "1rem",
									}}
									key={index}
									style={getCardStyles(item.shortCode)}
								>
									<Box
										sx={{
											display: "flex",
											justifyContent: "space-between",
											padding: "0.8rem",
											alignItems: "center",
										}}
										onClick={() => onProvinceSelectionChangeHandler(item)}
									>
										<Typography sx={{ fontWeight: "bold", fontSize: ".875rem" }}>
											{item.header}
										</Typography>

										{/* <Avatar
											shape="square"
											style={{
												background: "#fff",
												// color: "#fff",
												borderRadius: "10%",
												fontWeight: "bold",
												fontSize: ".775rem",
												padding: "4px",
												height: "22px",
												width: "50px",
												
												// border- radius: 10%;
												
											}}


										> */}
										<img src={provinceImages[item.shortCode]} alt="province-logo"
										/>
										{/* </Avatar> */}
									</Box>

									{
										openCard[item.shortCode] && (
											<>
												<Divider className="m-0" />
												<Box
													sx={{
														padding: "0.6rem",
														fontSize: ".875rem",
														color: "rgba(0, 0, 0, 0.6)",


														"& .dropDownWrapper": { marginBottom: ".5rem !important" }
													}}
												>
													{statutoryHolidayDDL && statutoryHolidayDDL[item.shortCode] && statutoryHolidayDDL[item.shortCode].length > 0 && <EnhancedDropDownRHFWithLabel
														selectName={item.dateEffectiveId}
														label="Effective Date"
														labelPosition={LabelPosition.Left}
														required
														testId={`date-effective`}
														items={statutoryHolidayDDL[item.shortCode] ?? []}
														// items={item.dateEffectiveItems || []}
														// selectedItem={item.dateEffectiveItems[0].value}
														selectedItem={statutoryHolidayDDL[item.shortCode]?.[0]?.value}
														labelColumns={4}
														fieldColumns={8}
													/>}
													{statutoryHolidayDDL && statutoryHolidayDDL[item.shortCode] && statutoryHolidayDDL[item.shortCode].length === 0 && <EnhancedDropDownRHFWithLabel
														selectName={item.dateEffectiveId}
														label="Effective Date"
														labelPosition={LabelPosition.Left}
														required
														testId={`date-effective`}
														items={[]}
														labelColumns={4}
														fieldColumns={8}
													/>}

													<span
														style={{
															fontWeight: "600",
														}}
													>
														Regular & Continuous Employees{" "}
													</span>
													<span>{item.regularAndContinuousEmployees}</span>

													<Box
														sx={{
															"& .MuiFormControlLabel-label": {
																fontSize: "0.875rem",
															},
														}}
													>
														{item.regularAndContinuousEmployeesOptions?.[0]
															?.label &&
															item.regularAndContinuousEmployeesOptions.length ===
															1 && (
																<span>
																	{
																		item.regularAndContinuousEmployeesOptions[0]
																			.label
																	}
																</span>
															)}
														{item.regularAndContinuousEmployeesOptions?.[0]
															?.label &&
															item.regularAndContinuousEmployeesOptions.length >
															1 && (
																<EnhancedRadioGroupRHF
																	name={
																		item.regularAndContinousEmployeesOptionsName
																	}
																	key={item.regularAndContinousEmployeesOptionsName}
																	// selectedValue="regularContinuous"
																	selectedValue={item.regularAndContinuousEmployeesOptions[0].value}
																	testId={"regular-and-continuous-employees"}
																	disabled={false}
																	options={
																		(item.regularAndContinuousEmployeesOptions &&
																			item.regularAndContinuousEmployeesOptions) ||
																		[]
																	}

																/>
															)}
													</Box>
													<span
														style={{
															fontWeight: "600",
														}}
													>
														Regular Employees{" "}
													</span>
													<span>{item.regularEmployees}</span>
													<Box
														sx={{
															"& .MuiFormControlLabel-label": {
																fontSize: "0.875rem",
															},
														}}
													>
														{item.regularEmployeesOptions?.[0]?.label &&
															item.regularEmployeesOptions.length === 1 && (
																<span>{item.regularEmployeesOptions[0].label}</span>
															)}
														{item.regularEmployeesOptions?.[0]?.label &&
															item.regularEmployeesOptions.length > 1 && (
																<EnhancedRadioGroupRHF
																	name={item.regularEmployeesOptionsName}
																	// selectedValue="regular"
																	selectedValue={item.regularEmployeesOptions[0].value}
																	key={item.regularEmployeesOptionsName}
																	testId={"regular-employees"}
																	disabled={false}
																	options={
																		(item.regularEmployeesOptions &&
																			item.regularEmployeesOptions) ||
																		[]
																	}
																/>
															)}
													</Box>
													{item.continuousEmployeesOptions?.[0] &&
														item.continuousEmployeesOptions.length > 0 && (
															<>
																<span
																	style={{
																		fontWeight: "600",
																	}}
																>
																	Continuous Employees{" "}
																</span>
																<span>{item.continuousEmployee}</span>
															</>
														)}

													<Box
														sx={{
															"& .MuiFormControlLabel-label": {
																fontSize: "0.875rem",
															},
														}}
													>
														{item.continuousEmployeesOptions?.[0] &&
															item.continuousEmployeesOptions.length > 1 && (
																<EnhancedRadioGroupRHF
																	name={item.ContinuousEmployeesOptionsName}
																	key={item.ContinuousEmployeesOptionsName}
																	// selectedValue="continuous"
																	selectedValue={item.continuousEmployeesOptions[0].value}
																	testId={"continuous-employees"}
																	disabled={false}
																	options={
																		(item.continuousEmployeesOptions &&
																			item.continuousEmployeesOptions) || [""]
																	}
																/>
															)}

														{item.continuousEmployeesOptions.length === 1 && (
															<span>
																{item.continuousEmployeesOptions[0].label}
															</span>
														)}
													</Box>
												</Box>
												<Toolbar
													sx={{
														display: "flex",
														justifyContent: "center",
													}}
												>
													<EnhancedButtonPrimeReact
														label="Submit"
														// loading={isSubmitting}
														// type="submit"
														// icon="pi pi-check"
														onClickHandler={() =>
															onSubmitPayCalculationsRules(
																item.shortCode,
																item.header
															)
														}
														raised
														severity={EnhancedButtonPrimeReactSeverity.Success}
													/>
													<EnhancedButtonPrimeReact
														// icon="pi pi-plus"
														label="Reset"
														raised
														onClickHandler={() =>
															onResetCardButtonClicked(item.shortCode, item.header)
														}
														style={{ marginLeft: "1rem" }}
														severity={EnhancedButtonPrimeReactSeverity.Secondary}
													/>
												</Toolbar>
											</>
										)
									}
								</Card>
							))}
					</Box>
				</Box>
			</Grid >
		);
	};
